import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { useGetTableObjectInfoQuery, useGetCardsStructureQuery } from "../../../../api/rtk/base/slices/cardsApiSlice";

type UseObjectInfoCardDataArgs = {
    objectTypeName?: string
    objectId?: string
}

export function useObjectInfoCardData({ objectTypeName, objectId }: UseObjectInfoCardDataArgs) {
    const objectTypes = getItemWebStorage("objectTypes");
    const { queryType = 'objects' } = objectTypes?.find(objectType => objectType.name === objectTypeName) ?? {};
    const currentConfig = getItemWebStorage("currentConfig");
    const structureSuffix = currentConfig?.structureSuffix

    const {
        data: cardsStructure,
        isFetching: isFetchingCardsStructure,
        isError: isCardsStructureError,
        isSuccess: isCardsStructureSuccess
    } = useGetCardsStructureQuery({ structureSuffix });

    const {
        data: objectInfo,
        error: objectInfoError,
        isFetching: isFetchingObjectInfo
    } = useGetTableObjectInfoQuery({ queryType, objectType: objectTypeName, objectId }, { skip: !isCardsStructureSuccess });

    return {
        queryType,
        cardsStructure,
        isFetchingCardsStructure,
        isCardsStructureError,
        objectInfo,
        isFetchingObjectInfo,
        objectInfoError,
    }
}


